import React, { useEffect, useState } from "react";
import { Company } from "./Company";
import { useAxios } from "../../shared/technical/rest/AxiosProvider";
import { getAllCompanies } from "./CompaniesApi";
import { useAccount } from "../users/AccountProvider";
import { isCompanyAdmin } from "../users/AccountServiceRoles";
import { MuiRhfAutocompleteListField } from "../../shared/components/forms/MuiRhfAutocompleteListField";

export function MuiRhfCompanySelectField(props: {
  name: string,
  label: string,
  required?: boolean,
  disabled?: boolean,
}) {
  const axios = useAxios();
  const account = useAccount();
  const [companies, setCompanies] = useState<Company[]>([]);

  useEffect(() => {
    if (isCompanyAdmin(account)) {
      setCompanies([account.company!!])
    } else {
      getAllCompanies(axios).then(setCompanies);
    }
  }, [axios, account])

  if(companies.length === 0) {
    return <></>;
  }

  return (
    <MuiRhfAutocompleteListField
      name={props.name}
      label={props.label}
      list={companies}
      getListLabel={(company) => company.name}
      getListKey={(company) => company.id!!}
      required={props.required}
      disabled={props.disabled}
      slotProps={{
        popper: {
          placement: 'bottom-start'
        }
      }}
    />
  )
}

